<style lang="stylus" scoped>
    .hotAlbum
        .hotAlbum-box
            display flex
            justify-content space-between
            align-items center

            .hotAlbum-box__title
                font-size 18px
                font-weight 400

            .hotAlbum-box__allAlbum
                font-size 14px
                cursor pointer
                transition all .2s ease-in-out
                background #fff
                box-shadow 0 0 4px rgba(0,0,0,.15)
                border-radius 15px
                padding 6px 10px

        .hotAlbum-list
            display flex
            justify-content flex-start
            flex-wrap wrap
            overflow hidden
            height 180px

            img
                width 301px
                // max-width 23.5%
                margin 28px 0 32px
                cursor pointer
                border-radius 6px
                &:not(:first-child)
                    margin-left 25px
    .hotAlbum.dark-theme_album
        .hotAlbum-box__title
            color #fff
        .hotAlbum-box__allAlbum
            background #222
            color #fff
</style>

<template>
    <div class="hotAlbum container" :class="{ 'dark-theme_album': isPCDarkMode == 2 }">
        <div class="hotAlbum-box">
            <div class="hotAlbum-box__title">{{ recommendTitle.hot }}</div>
            <div class="hotAlbum-box__allAlbum" @click="showAllAlbum">{{ recommendTitle.allAlbum }}</div>
        </div>
        <div class="hotAlbum-list">
            <img
                v-for="(item, index) in recommendNum"
                :src="albumList[index] ? `${window['GLOBAL'].PUBLIC_OSS_HOST + albumList[index].cover_url}main.png` : ''"
                alt="专题页图片"
                @click="showAlbumList(index)"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "recommendAlbum",
        data() {
            return {
                recommendTitle: {
                    hot: "热门专辑",
                    allAlbum: "全部专辑 >",
                },
                recommendNum: new Array(10),
            };
        },
        computed: {
            albumList() {
                return this.$store.state.tplCenter.albumList;
            },
            activeAlbumID() {
                return this.$store.state.tplCenter.activeAlbumID;
            },
            baseOrder() {
                return this.$store.state.baseOrder;
            },
        },
        methods: {
            showAlbumList: function (index) {
                this.sensors.track("albumPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: this.albumList[index].id,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "detail",
                });
                this.$bus.$emit("clearSearch");
                this.$bus.$emit("updateFilter", {
                    page: 1,
                    album: this.albumList[index].id,
                    offset: 0,
                    classId: 0,
                    order: this.baseOrder,
                    price: this.$store.state.workFilter.price,
                    search: "",
                });
                this.$store.commit("cleanActiveLab", this.$store.state.tplCenter.editorTags[0]);
            },
            showAllAlbum() {
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "list",
                });
            },
            toAlbum: function (id) {
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: id,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "detail",
                });
                this.$bus.$emit("clearSearch");
                this.$bus.$emit("updateFilter", {
                    page: 1,
                    album: id,
                    offset: 0,
                    order: this.baseOrder,
                    price: this.$store.state.workFilter.price,
                    classId: 0,
                });
                this.$store.commit("cleanActiveLab", this.$store.state.tplCenter.editorTags[0]);
            },
        },
        created() {},
        mounted() {
            this.$bus.$on("toAlbum", (id) => {
                this.toAlbum(id);
            });
            this.$bus.$on("toAlbumByKey", (key) => {
                let id = 0;
                for (let item of this.albumList) {
                    if (item.title.indexOf(key) != -1) {
                        id = item.id;
                        break;
                    }
                }
                if (!id) return;
                this.toAlbum(id);
            });
        },
        beforeDestroy() {
            this.$bus.$off("toAlbum");
            this.$bus.$off("toAlbumByKey");
        },
    };
</script>
